module.exports = __webpack_public_path__ + "media/images/temp/icon-3-b9ef7d72eda0dd10b5747ff629ac6e69.png";